// extracted by mini-css-extract-plugin
export default {"likeButton":"oT-z","unLikedButton":"pT-z","likedButton":"qT-z"};